import React from 'react';
import { motion } from 'framer-motion';
import { Users, Star, BookOpen, CheckCircle } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: Users,
    label: '+1.000 Personas'
  }, {
    icon: Star,
    label: '9.7/10 Resultados'
  }, {
    icon: BookOpen,
    label: '+200 páginas Sistema completo'
  }, {
    icon: CheckCircle,
    label: '100% probado Paso a paso real'
  }];
  return <section className="w-full bg-green-900 text-white py-6 md:py-8 px-4" data-id="element-247">
      <div className="max-w-7xl mx-auto" data-id="element-248">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-xs md:text-sm mb-4 md:mb-6 font-medium text-green-200 uppercase tracking-wider" data-id="element-249">
          Respaldado por personas reales que ya empezaron desde cero
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-250">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-251">
              <stat.icon className="w-6 h-6 md:w-8 md:h-8 mb-2 text-lime-400" data-id="element-252" />
              <p className="text-xs md:text-sm font-bold" data-id="element-253">{stat.label}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}